import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { X } from 'lucide-react';

const LanguagePrompt = () => {
  const { language, switchLanguage, showLanguagePrompt, dismissPrompt } = useLanguage();
  
  if (!showLanguagePrompt) return null;
  
  const targetLang = language === 'en' ? 'fr' : 'en';
  const messages = {
    en: {
      message: 'Ce site est également disponible en français',
      switch: 'Passer en français',
      stay: 'Stay in English'
    },
    fr: {
      message: 'This site is also available in English',
      switch: 'Switch to English',
      stay: 'Rester en français'
    }
  };
  
  const content = messages[language];
  
  return (
    <div style={{
      position: 'fixed',
      bottom: '24px',
      right: '24px',
      background: 'var(--bg-primary)',
      border: '1px solid var(--border-light)',
      padding: '24px',
      maxWidth: '320px',
      zIndex: 9998,
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
    }}>
      <button
        onClick={dismissPrompt}
        style={{
          position: 'absolute',
          top: '12px',
          right: '12px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '4px',
          color: 'var(--text-light)'
        }}
        aria-label="Dismiss"
      >
        <X size={16} />
      </button>
      
      <p className="body-regular" style={{ 
        marginBottom: '16px',
        color: 'var(--text-secondary)',
        fontSize: '14px'
      }}>
        {content.message}
      </p>
      
      <div style={{ display: 'flex', gap: '12px' }}>
        <button
          onClick={() => switchLanguage(targetLang)}
          style={{
            background: 'var(--interactive-base)',
            color: 'var(--bg-primary)',
            border: 'none',
            padding: '10px 16px',
            fontSize: '12px',
            fontFamily: "'Suisse Medium', sans-serif",
            cursor: 'pointer',
            letterSpacing: '0.05em',
            textTransform: 'uppercase'
          }}
        >
          {content.switch}
        </button>
        <button
          onClick={dismissPrompt}
          style={{
            background: 'none',
            color: 'var(--text-secondary)',
            border: '1px solid var(--border-medium)',
            padding: '10px 16px',
            fontSize: '12px',
            fontFamily: "'Suisse Regular', sans-serif",
            cursor: 'pointer',
            letterSpacing: '0.05em',
            textTransform: 'uppercase'
          }}
        >
          {content.stay}
        </button>
      </div>
    </div>
  );
};

export default LanguagePrompt;
